import React from 'react';
import TabSchema from '../tabSchema';
import ReconciliationFile from "../../../components/pages/Reconciliation/Files/Files"
import GenerateReconReport from './GenerateReport';
import Dashboard from './Dashboard/Dashboard';
import { useAuth } from '../../context/API_Client';

const Reconciliation = (operationPermissions) => {
    console.log('operationPermissions', operationPermissions);
    const { isAuthorizedPermission } = useAuth();

    const tabSchema = [
        ...(isAuthorizedPermission(operationPermissions?.viewMerchantReportDashBoard) ? [{
            label: 'Dashboard',
            value: '0',
            content: <Dashboard operationPermissions={operationPermissions} />,
        }] : []),
        {
            label: 'Upload File',
            value: '1',
            content: <ReconciliationFile operationPermissions={operationPermissions} />
        },
        ...(isAuthorizedPermission(operationPermissions?.viewReports) ? [{
            label: 'Generate Report',
            value: '2',
            content: <GenerateReconReport operationPermissions={operationPermissions} />,
        }] : []),
    ];

    console.log('tabSchema', tabSchema);

    return (
        <div className="content-wrapper" style={{ background: "white" }}>
            <section className="content">
                <div style={{ width: '100%' }}>
                    <TabSchema tabs={tabSchema} tabKey="reconTab" />
                </div>
            </section>
        </div>
    )
}

export default Reconciliation